import { getEnvVar } from "common/utilities/ generic";

const URL_PRE = getEnvVar("REACT_APP_PLATFORM_URL_PRE");

const restEndPointURLs = {
    BREEDS_DOG: "fdp-pet-service/v1/pets/attributes/DOG/breeds",
    BREEDS_CAT: "fdp-pet-service/v1/pets/attributes/CAT/breeds",
    ZIPCODE_SERVICEABILITY_VALIDATION: "fdp-workflow-service/v1/workflows/zip-code-validation",
    EMAIL_VALIDATION: "fdp-lookup-service/v1/lookup/email",
    RE_RATE_CART: `fdp-workflow-service/v1/workflows/carts`,
    GET_CUSTOMER_AND_PROSPECT_DATA: "fdp-workflow-service/v1/workflows/prospect-details",
    QUOTE_API: "fdp-partner-api/v1/partners/browse/quotes",
};

Object.keys(restEndPointURLs).map((key) => (restEndPointURLs[key] = `/${URL_PRE}/${restEndPointURLs[key]}`));

export default restEndPointURLs;
